export default __webpack_public_path__ + "static/media/20.c08e47d9.png";